import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { holdingMapper } from "@domains/mapper/Reports/HoldingMapper";
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class HoldingReportRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getHoldingReportData(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const accType = await this.accountDetails.getAccTyp();
        let url;
        if ((req === null || req === void 0 ? void 0 : req.familyAccodes) && (req === null || req === void 0 ? void 0 : req.familyAccodes) !== accountCode) {
            url = new URL(urlConfig.consolidatedDetails + "/v1");
            url.searchParams.append("accountIds", req.familyAccodes);
        }
        else {
            url = new URL(urlConfig.holdingReportUrl + "/v1");
            url.searchParams.append("accountId", accountCode);
        }
        if (accType !== "CO") {
            const holdingsReportData = await this.http.makeApiCall({
                method: "GET",
                url: url.toString(),
                headers: getReportHeaders(accountCode),
                signal: req.abortSignal,
                avoidAuthToken: getIsInIFrame(),
            });
            const newHoldingReportData = holdingMapper(holdingsReportData === null || holdingsReportData === void 0 ? void 0 : holdingsReportData.data);
            return newHoldingReportData;
        }
    }
}
export default HoldingReportRepository;
